// Storage/wallet convention is Rial, bigint, no floats (docs/data-model.md
// #wallet) — display convention throughout landing (incl. /app) is Toman.
const RIAL_PER_TOMAN = 10n;

export function formatTomanFromRial(rial: string) {
  const toman = BigInt(rial) / RIAL_PER_TOMAN;
  return `${toman.toLocaleString("fa-IR")} تومان`;
}

/** An order row's amount: a discount (negative) as «−X تومان». */
export function formatAdjustment(rial: string) {
  const value = BigInt(rial);
  return value < 0n ? `−${formatTomanFromRial((-value).toString())}` : formatTomanFromRial(rial);
}

/** The price line of a product card: Toman, or the sales-halt text (F17). */
export function priceLabel(priceRial: string | null) {
  return priceRial === null ? "قیمت در دسترس نیست" : formatTomanFromRial(priceRial);
}

export const METAL_FA = { gold: "طلا", silver: "نقره" } as const;
